export const noti = {
    text1: "Notifiche",
    text2: "Elenco delle notifiche.",
    text3: "Non hai notifiche",
};